import ReactSelect from "react-select";
import styled from "styled-components/macro";
import { Flex } from "../../components/Common.Styled";
const defaultLanguage = window.localStorage.getItem("rcml-lang") || "en";

export const Cont = styled.div`
  padding: 1em 0;
`;

export const Title = styled.h2`
  font-weight: 500;
  font-size: 1.25em;
  margin-left: ${defaultLanguage === "ar" ? "0 !important" : "0"};
  margin-right: ${defaultLanguage === "ar" ? "0.5rem !important" : "0"};
  @media (max-width: 1121px) {
    font-size: 1.15em;
  }
  @media (max-width: 687px) {
    font-size: 1em;
  }
  @media (max-width: 565px) {
    font-size: 0.9em;
  }
`;

export const SearchCont = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  border: 1px solid #dadada;
  border-radius: 6px;
`;

export const SearchIcon = styled.div`
  margin-left: 1rem;
  width: 3%;
  font-size: 1.2rem;
`;

export const SearchInputField = styled.input`
  height: auto;
  border: none;
  outline: none;
  width: 100%;
  text-align: ${defaultLanguage === "ar" ? "right" : "left"};
  font-weight: 500;
  font-size: 0.9rem;
  font-family: Montserrat;
  letter-spacing: 0px;
  opacity: 0.8;
  padding: 0px 9px;
  color: rgb(49, 53, 59);
  @media (max-width: 426px) {
    font-size: 0.8em;
    padding: 0px 15px;
  }
`;

export const PropertySaleButton = styled.div`
  /* box-shadow: rgb(0 0 0 / 19%) 0px 0px 10px; */
  border-radius: 0px 0px 0px 16px;
  opacity: 1;
  /* margin: 0.1em; */
  white-space: nowrap;
  padding: 1.2em 2.5em;
  border: 1px solid #dadada;
  background: #ebf0f8 0% 0% no-repeat padding-box;
  color: #15396d;
  outline: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out 0s;
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  font-family: Montserrat;
  letter-spacing: 0px;
`;

export const SearchButton = styled.div`
  /* box-shadow: rgb(0 0 0 / 19%) 0px 0px 10px; */
  border-radius: 4px;
  opacity: 1;
  /* margin: 0.1em; */
  white-space: nowrap;
  padding: 0.5em 1em;
  border: 1px solid #dadada;
  background: #ed7d2b 0% 0% no-repeat padding-box;
  color: #ffffff;
  outline: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out 0s;
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  font-family: Montserrat;
  letter-spacing: 0px;
  margin: 0.5rem;
  @media (max-width: 1121px) {
    padding: 0.3em 1em;
    font-size: 0.9rem;
  }
  @media (max-width: 565px) {
    margin: 0.3rem;
    font-size: 0.8rem;
  }
`;

export const VFilterCont = styled.div`
  position: relative;
  padding: 1em;
  border-radius: 0.25em;
  border: 1px solid #d2d2d2;
  font-size: 16px;
  width: 100%;
  direction: ${defaultLanguage === "ar" ? "rtl" : "ltr"};
`;
export const VFilterConts = styled.div`
  position: relative;
  padding: 1em;
  border-radius: 0.25em;
  border: 1px solid #d2d2d2;
  font-size: 16px;
  width: 25%;
  background-color: white;
  margin-top: 1rem;
`;

export const VFilterSubmitButtons = styled.div`
  position: absolute;
  top: 0.75em;
  right: ${defaultLanguage === "ar" ? "10em" : "1em"};

  @media (max-width: 555px) {
    top: 3.05em;
  }
`;

export const VFilterSubmitButton = styled.button`
  color: ${(props) => (props.type === "reset" ? "#FC4500" : "#004CFF")};
  font-weight: bold;
  font-size: 0.9em;
  margin-left: ${defaultLanguage === "ar" ? "0 !important" : ""};
  margin-right: ${defaultLanguage === "ar" ? "1rem" : ""};
  @media (max-width: 969px) {
    font-size: 0.75em;
  }
`;

export const VFilterItem = styled.div`
  padding: 1em 0 0 0;
  border-bottom: 1px solid #d2d2d2;

  &:last-child {
    border-bottom: none;
  }
`;

export const VFilterItemTitleWrp = styled((props) => <Flex jc="sb" ai="c" {...props} />)`
  margin-bottom: 0.5em;
`;

export const VFilterItemTitle = styled.h3`
  margin: 0;
  font-weight: 600;
  font-size: 1em;
  @media (max-width: 969px) {
    font-size: 0.8em;
  }
`;

export const VFilterItemTitleSub = styled.span`
  color: #474747;
  font-size: 0.8em;
  font-weight: bold;
  @media (max-width: 694px) {
    font-size: 0.7em;
  }
`;

export const VFilterRadioGroup = styled((props) => <Flex wrap {...props} />)``;

export const VFilterRadioInput = styled((props) => <input type="radio" {...props} />)`
  accent-color: #fc4500;
`;

export const VFilterCheckInput = styled((props) => <input type="checkbox" {...props} />)`
  accent-color: #fc4500;
`;

export const VFilterRadioLabel = styled((props) => <label {...props} />)`
  margin-left: ${defaultLanguage === "ar" ? "0" : "0.5em"};
  margin-right: ${defaultLanguage === "ar" ? "0.5em" : "0"};
  @media (max-width: 694px) {
    font-size: 0.8rem;
  }
`;

export const VFilterRadioItem = styled(({ inpProps, labelProps, labelContent, ...props }) => <Flex ai="c" {...props} />)`
  margin-right: 1em;
`;

export const VFilterSelect = styled(ReactSelect)`
  [class$="-menu"] {
    z-index: 999;
  }
`;

export const VFilterBoxedCont = styled((props) => <Flex {...props} />)``;

export const VFilterBoxedButton = styled.button`
  display: block;
  flex: 1;
  flex-basis: 25%;
  margin-right: 1em;
  margin-bottom: 1em;
  padding: 0.5em 1em;
  cursor: pointer;
  border-radius: 0.25em;
  box-shadow: 0 0 0 1px #bfbfbf;

  &:nth-child(3n) {
    margin-right: 1em;
  }

  &.selected {
    background: #ed7d2b;
    color: #fff;
    box-shadow: 0 0 0 2px #ed7d2b;
  }
  @media (max-width: 951px) {
    font-size: 0.8rem;
  }
`;

export const StatusText = styled.div`
  margin-left: 0.5rem;
`;

export const FilterTitle = styled.div`
  font-weight: 600;
  font-size: 1.25em;
  @media (max-width: 1121px) {
    font-size: 1.15em;
  }
  @media (max-width: 687px) {
    font-size: 1em;
  }
  @media (max-width: 565px) {
    font-size: 0.9em;
  }
`;
